import './index.css';
const Error404 = () => {
  return (
    <div className="box_404">
      <img src="/no-data-found.png" alt='No Date Found' className='image_404' />
    </div>
  );
};
export default Error404;
